import { render, staticRenderFns } from "./RegistrationSuccess.vue?vue&type=template&id=1aefb39a&scoped=true&"
import script from "./RegistrationSuccess.vue?vue&type=script&lang=js&"
export * from "./RegistrationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aefb39a",
  null
  
)

export default component.exports